<template>
  <div>
    <el-dialog v-model="myTakeNotesShow" title="Tips" width="500" :show-close="false">
      <template #header>
        <div class="header">记笔记</div>
        <div class="close_icon cursor_pointer">
          <el-icon :size="20" @click="closePopup">
            <CloseBold />
          </el-icon>
        </div>
      </template>
      <div class="dialog_content">
        <div class="input_box">
          <el-input v-model="noteInfo.content" style="width: 100%; height: 350px" maxlength="500" placeholder="请输入"
            show-word-limit type="textarea" autosize />
          <div class="btn_box mar_top_20 flex FlexjustifyEnd">
            <div class="btn_save cursor_pointer" @click="addNote">保存</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "GjkcTakeNotes",

  data() {
    return {
      myTakeNotesShow: false,
      noteInfo: {
        chapterId: '',
        content: '',
        imgs: '',
      }
    };
  },

  mounted() { },

  methods: {
    closePopup() {
      this.myTakeNotesShow = false;
      this.noteInfo = {
        chapterId: '',
        content: '',
        imgs: '',
      }
    },
    // 记笔记（保存）
    addNote() {
      if (!this.noteInfo.content) {
        this.$Dialog.toast("请输入笔记内容后再保存", { type: 'error' });
        return
      }
      this.$Api.course.addNote(this.noteInfo).then(res => {
        this.$Dialog.toast('保存成功');
        this.closePopup();
        console.log(res)
      }).catch(err => {
        console.log(err);
      })
    }
  },
};
</script>
<style lang="scss" scoped>
:deep(.el-dialog) {
  width: 362px;
  height: 545px;
  background: #f5f6f8;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}

:deep(.el-dialog__header) {
  position: relative;
  padding: 0 20px;
  box-sizing: border-box;
  text-align: start;
}

.header {
  //   text-align: center;
  //   font-weight: bold;
  font-size: 20px;
  color: #333333;
  line-height: 60px;
  font-weight: 600;
  //   border-bottom: 1px solid rgba(36, 35, 36, 0.1);
}

.close_icon {
  position: absolute;
  top: 20px;
  right: 20px;
  color: #333333;
}

.dialog_content {
  .input_box {
    width: 322px;
    height: 446px;
    background: #ffffff;
    border-radius: 10px;
    padding: 15px;
    box-sizing: border-box;

    :deep(.el-textarea__inner) {
      box-shadow: none;
      resize: none;
    }

    .btn_box {
      border-top: 1px solid rgba(36, 35, 36, 0.1);
      padding: 10px 0;

      .btn_save {
        width: 94px;
        height: 36px;
        background: linear-gradient(90deg, #00d5c2, #00d498);
        border-radius: 18px;
        text-align: center;
        line-height: 36px;
        color: #ffffff;
      }
    }
  }
}
</style>